import { render, staticRenderFns } from "./updateMenu.vue?vue&type=template&id=bab1d264&lang=pug"
import script from "./updateMenu.vue?vue&type=script&lang=js"
export * from "./updateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports